// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3DkC8","infoBtn":"quickbooks_infoBtn__3GnT5","formBox":"quickbooks_formBox__3f3T3","formFooter":"quickbooks_formFooter__3fxTs"};